import script from "./ColorPickerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorPickerDialog.vue?vue&type=script&setup=true&lang=js"

import "./ColorPickerDialog.vue?vue&type=style&index=0&id=7cb5cc3b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb5cc3b"]])

export default __exports__